import { routes } from './routes';
import TEXT_STRING from './string';
import ERROR_STRINGS from './errorStrings';
import {
  QUICK_REPLY_ITEMS,
  QUICK_REPLY_QUESTION_MESSAGE_KIND,
} from './quickReply';
import Ranking1 from '../assets/images/ranking/ranking1.png';
import Ranking2 from '../assets/images/ranking/ranking2.png';
import Ranking3 from '../assets/images/ranking/ranking3.png';
import Ranking4 from '../assets/images/ranking/ranking4.png';
import Ranking5 from '../assets/images/ranking/ranking5.png';
import Ranking6 from '../assets/images/ranking/ranking6.png';
import Ranking7 from '../assets/images/ranking/ranking7.png';
import Ranking8 from '../assets/images/ranking/ranking8.png';
import Ranking9 from '../assets/images/ranking/ranking9.png';
import Ranking10 from '../assets/images/ranking/ranking10.png';
import ChargePoint from '../assets/images/chargePoint.png';
import IdSample from '../assets/images/idSamples/idSample.png';
import IdBackSample from '../assets/images/idSamples/idBackSample.png';
import IdSelfieSample from '../assets/images/idSamples/idSelfieSample.png';
import firebaseConfig from './firebaseConfig';

const storageKeys = {
  IS_CONFIRM_TUTORIAL: 'is_confirm_tutorial',
  ACCESS_TOKEN: 'access_token',
  CLIENT_ID: 'client_id',
  FILTER_FEMALE: 'filter_female',
  GIFT_SUGGESTIONS_DISPLAYED: 'gift_suggestions_displayed',
  FILTER_MALE: 'filter_male',
  IS_CONFIRM: 'is_confirm',
  POINT_TAB: 'point_tab',
  REFRESH_TOKEN: 'refresh_token',
  REQUIRE_SIGNUP: 'require_signup',
  USER_ID: 'user_id',
  BASIC_ID: 'basic_id',
  LINE_SESSION_TOKEN: 'line_session_token',
  LINE_SESSION_EXPIRES_AT_MS: 'line_session_expires_at_ms',
  LINE_OAUTH_NONCE: 'line_oauth_nonce',
  LINE_OAUTH_CSRF: 'line_oauth_csrf',
};

const SESSION_KEYS = {
  HOME_TAB: 'home_tab',
  DISCOUNT_TAB: 'discount_tab',
  INVITE_ID: 'invite_id',
  SEARCH_TAB: 'search_tab',
  RANKING: 'ranking',
  SW_RELOAD_PENDING: 'sw_reload_pending',
};

const COOKIE_KEYS = {
  APPLY_AB_TESTING: 'is_apply_ab_testing',
  INVITE_ID: 'invite_id',
  CLIENT_ID: 'client_id',
};

const queryKeys = {
  SALON_GACHA_TICKETS: 'salon_gacha_tickets',
  ACTIVITY_AREA: 'activity_area',
  ADMIN_LIST: 'admin_list',
  ADMIN_POSTER_DETAIL: 'admin_poster_detail',
  ADMIN_POSTER_POSTS: 'admin_poster_posts',
  BANK_TRANSFER_DETAIL: 'bank_transfer_detail',
  BODY_OPTIONS: 'BodyOptions',
  BUY_POINTS_HISTORY: 'buy_points_history',
  CARD_PAYMENT: 'card_payment',
  CHANNEL_DETAIL: 'channel_detail',
  CHANNEL_LIST: 'channel_list',
  CHECK_AUTHENTICATION: 'check_authentication',
  CLIENT_CHANNEL_DETAIL: 'client_channel_detail',
  CLIENT_CHANNEL_LIST: 'client_channel_list',
  CURRENT_USER: 'CurrentUser',
  POST_RECOMMEND: 'post_recommend',
  POST_MEMBER_BOARD: 'post_member_board',
  POST_PREMIUM: 'post_premium',
  POST_PURCHASED: 'post_purchased',
  DETAIL_POST: 'DetailPost',
  DETAIL_FEMALE: 'DetailFemale',
  FCM_TOKEN: 'fcm_token',
  FEMALES_MET: 'females_met',
  FEMALE_LIST: 'FemaleList',
  FEMALE_LIST_DISCOUNT: 'female_list_discount',
  FEMALE_RECOMMEND_LIST: 'female_recommend_list',
  SEARCH_SHELF_CARDS: 'search_shelf_cards',
  YARIKANO_GIRLS_PUBLIC: 'yarikano_girls_public',
  FEMALE_POST: 'female_post',
  FEMALE_RANK: 'female_rank',
  FILTER_OPTIONS: 'filter_options',
  FIND_USER: 'find_user',
  FOLLOWING_LIST: 'FollowingList',
  GAMES: 'Games',
  GIFT_DATA: 'gift_data',
  GIFT_LIST: 'gift_list',
  GIFT_PENDING_PAYMENT: 'gift_pending_payment',
  GIFT_PREDICT: 'gift_predict',
  LINE_LINK: 'line_link',
  LIST_PENDING_PAYMENT: 'list_pending_payment',
  LIST_POINTS: 'list_points',
  LIST_REVIEW: 'list_review',
  MALE_POST: 'male_post',
  MESSAGE_LIST: 'message_list',
  ORDER_HISTORY: 'order_history',
  PAYMENT: 'payment',
  PENDING_REQUEST_POINT: 'pending_request_point',
  POINTS: 'points',
  POINTS_PENDING: 'points_pending',
  POINT_USAGE_HISTORY: 'point_usage_history',
  PROHIBITED_WORDS: 'prohibited_words',
  PROJECT_FEMALES: 'project_females',
  PROJECT_INFO: 'ProjectInfo',
  PROJECT_PRICE: 'project_price',
  RECOMMEND_FEMALE: 'RecommendFemale',
  RECOMMEND_ORDER: 'RecommendOrder',
  SELECTED_GAMES: 'selected_games',
  STAR_RANK: 'star_rank',
  UNREAD_COUNT: 'unread_count',
  VIDEO_GAME: 'video_game',
  RANKING: 'ranking',
};

const MESSAGE_KEY = {
  GIRL_MEETING: 'girl_meeting',
  GIRL_CANCEL_MEETING: 'girl_cancel_meeting',
  ADMIN_RELEASE_PAYMENT: 'admin_release_payment',
  POST_PAY: 'post_pay',
  BANK_PAY: 'bank_pay',
};

const SALON_SITE_URL = 'https://teco-salon.com/';

const navBars = [
  { label: TEXT_STRING.NAVIGATION.SEARCH, icon: 'search', path: routes.SEARCH },
  { label: TEXT_STRING.NAVIGATION.HOME, icon: 'home', path: routes.HOME },
  {
    label: TEXT_STRING.NAVIGATION.CALL,
    img: '/images/logo192.png',
    path: routes.CALL,
  },
  {
    label: TEXT_STRING.NAVIGATION.MESSAGE,
    icon: 'message',
    path: routes.MESSAGE,
  },
  { label: TEXT_STRING.COMMON.MY_PAGE, icon: 'user', path: routes.MY_PAGE },
];

const TIMEZONE = process.env.REACT_APP_TIMEZONE || 'Asia/Tokyo';
const PAGE_SIZE = 15;
const FEMALE_CURRENT_POINT_PAGE_SIZE = 10;
const MAX_ORDER_GIRL = 20;
const PAGE_SIZE_POST = 30;
const DAY_IN_WEEK = 7;
const TOKYO_AREA_ID = 2;
const TIME_VIEW_FORMAT = `HH${TEXT_STRING.COMMON.HOUR}mm`;
const DATE_TIME_VIEW_FORMAT = `LL ${TIME_VIEW_FORMAT}`;
const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm';
const SLASH_DATE_TIME_FORMAT = 'YYYY/MM/DD - HH:mm';
const DATE_FORMAT = 'YYYY/MM/DD';
const TIME_FORMAT = 'HH:mm';
// At Teco, a working day starts at 11:00 a.m. (matches teco-backend START_TIME_OF_THE_DAY)
const START_TIME_OF_THE_DAY = 11;
const START_DAY_WORK = '11:00';
const LIMIT_FILE = 4;
const RANKING_LIMIT = 10;
const READY_TO_GO_TIME = {
  BEGIN: '6:00',
  END: '20:00',
};
const VIDEO_ACCEPTED = ['video/mp4', 'video/mov', 'video/quicktime'];
const IMAGE_ACCEPTED = [
  'image/png',
  'image/jpg',
  'image/jpeg',
  'image/apng',
  'image/avif',
  'image/gif',
  'image/svg+xml',
  'image/webp',
];
const MESSAGE_SIZE = 25;
const DEBOUNCE_SEND_MESSAGE_ACTIVE = 1500;
const REFETCH_UNREAD_COUNT_TIMEOUT = 2000;
const REDIRECT_DELAY_MS = 3000;
const DEBOUNCE_CLICK = 500;
const DEBOUNCE_TEXT = 500;
const ONE_MB = 1024 * 1024;
const MAX_FILE_SIZE_PUBNUB = ONE_MB * 5; // 5MB
const MAX_FILE_SIZE = ONE_MB * 10; // 10MB
const INTERVAL_SEND_ACTIVE = 60 * 1000;
const NORMAL_PRICE = 20000;
const TIME_SHOW_REVIEW = 30 * 1000; // 30s
const MIN_NUMBER_SEARCH = 2;
const MAX_STAR = 5;
const LIMIT_VALUE = {
  MAX_REQUEST_IMAGE: 8,
  MAX_AGE: 999,
  MIN_AGE: 1,
  MAX_NUMBER: 1999999999,
  MIN_NUMBER: 0,
  MIN_AMOUNT_CARD: 100,
  // Minimum price to get star (one man JPY)
  MIN_PRICE_EMPTY_STAR: 0,
  MIN_PRICE_ONE_STAR: 5,
  MIN_PRICE_TWO_STAR: 20,
  MIN_PRICE_THREE_STAR: 50,
  MIN_PRICE_FOUR_STAR: 100,
  MIN_PRICE_FIVE_STAR: 200,
  MAX_PAYMENT_VISA: 450000,
};
const ONE_MAN_JPY = 10000;
const OWN_COMPANY_FRANCHISE_ID = 1;
const EXCEED_FRANCHISE_GAME = {
  SINGLE: 3,
  GROUP: 5,
};

const SIGNAL_EVENT = {
  TYPING_ON: 'TYPING_ON',
  TYPING_OFF: 'TYPING_OFF',
  REVIEW_GIRL: 'REVIEW_GIRL',
  DISBAND_MEMBER: 'DISBAND_MEMBER',
  DELETE_MESSAGE: 'DELETE_MESSAGE',
  REVIEWED_MEMBER: 'REVIEWED_MEMBER',
  PROJECT_INVITED: 'PROJECT_INVITED',
  PROJECT_PENDING_REVIEW: 'PROJECT_PENDING_REVIEW',
  PROJECT_ACCOUNTING_COMPLETED: 'PROJECT_ACCOUNTING_COMPLETED',
};

const ERROR_CODES = {
  INVALID_LINE_SESSION_TOKEN: 'INVALID_LINE_SESSION_TOKEN',
};

const HTTP_STATUS = {
  NOT_FOUND: 404,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500,
  SERVICE_UNAVAILABLE: 503,
  GATEWAY_TIMEOUT: 504,
  CONFLICT: 409,
  UNPROCESSABLE_ENTITY: 422,
  TOO_MANY_REQUESTS: 429,
  NOT_IMPLEMENTED: 501,
  NOT_ACCEPTABLE: 406,
  REQUEST_TIMEOUT: 408,
  LENGTH_REQUIRED: 411,
  PRECONDITION_FAILED: 412,
  PAYLOAD_TOO_LARGE: 413,
  UNSUPPORTED_MEDIA_TYPE: 415,
  REQUESTED_RANGE_NOT_SATISFIABLE: 416,
  FAILED_DEPENDENCY: 424,
  LOCKED: 423,
  METHOD_NOT_ALLOWED: 405,
  PRECONDITION_REQUIRED: 428,
  URI_TOO_LONG: 414,
  NETWORK_AUTHENTICATION_REQUIRED: 511,
};

const YARIKANO_BANNER_INSERT_INDEX = 3;
const PICKUPS_SCROLL_CONTAINER_ID = 'scrollFemaleCurrentPoint';
const YARIKANO_GIRLS_SCROLL_CONTAINER_ID = 'yarikanoGirlsScrollContainer';
// JSX では data-horizontal-scroll をリテラル指定。判定側は HORIZONTAL_SCROLL_SELECTOR を使う。
const HORIZONTAL_SCROLL_DATA_ATTR = 'horizontal-scroll';
const HORIZONTAL_SCROLL_SELECTOR = `[data-${HORIZONTAL_SCROLL_DATA_ATTR}]`;

export {
  routes,
  storageKeys,
  queryKeys,
  navBars,
  ERROR_STRINGS,
  TIMEZONE,
  PAGE_SIZE,
  FEMALE_CURRENT_POINT_PAGE_SIZE,
  ChargePoint,
  TEXT_STRING,
  DATE_TIME_VIEW_FORMAT,
  DATE_TIME_FORMAT,
  DATE_FORMAT,
  TIME_VIEW_FORMAT,
  LIMIT_FILE,
  RANKING_LIMIT,
  VIDEO_ACCEPTED,
  IMAGE_ACCEPTED,
  SESSION_KEYS,
  MAX_ORDER_GIRL,
  MESSAGE_SIZE,
  SIGNAL_EVENT,
  ERROR_CODES,
  HTTP_STATUS,
  DEBOUNCE_SEND_MESSAGE_ACTIVE,
  REFETCH_UNREAD_COUNT_TIMEOUT,
  REDIRECT_DELAY_MS,
  MAX_FILE_SIZE,
  INTERVAL_SEND_ACTIVE,
  firebaseConfig,
  DEBOUNCE_CLICK,
  NORMAL_PRICE,
  DEBOUNCE_TEXT,
  MIN_NUMBER_SEARCH,
  DAY_IN_WEEK,
  MAX_STAR,
  TIME_SHOW_REVIEW,
  MESSAGE_KEY,
  LIMIT_VALUE,
  ONE_MAN_JPY,
  PAGE_SIZE_POST,
  MAX_FILE_SIZE_PUBNUB,
  OWN_COMPANY_FRANCHISE_ID,
  EXCEED_FRANCHISE_GAME,
  SLASH_DATE_TIME_FORMAT,
  ONE_MB,
  TIME_FORMAT,
  START_DAY_WORK,
  START_TIME_OF_THE_DAY,
  COOKIE_KEYS,
  TOKYO_AREA_ID,
  READY_TO_GO_TIME,
  IdSample,
  IdSelfieSample,
  IdBackSample,
  Ranking1,
  Ranking2,
  Ranking3,
  Ranking4,
  Ranking5,
  Ranking6,
  Ranking7,
  Ranking8,
  Ranking9,
  Ranking10,
  YARIKANO_BANNER_INSERT_INDEX,
  PICKUPS_SCROLL_CONTAINER_ID,
  YARIKANO_GIRLS_SCROLL_CONTAINER_ID,
  HORIZONTAL_SCROLL_SELECTOR,
  SALON_SITE_URL,
  QUICK_REPLY_ITEMS,
  QUICK_REPLY_QUESTION_MESSAGE_KIND,
};

export * from './yarikanoChat';
